import { TRACING_GAME_SOUND_KEYS, TRACING_GAME_SOUND_VOLUMES } from '../audio';

import type Phaser from 'phaser';

const DRAWING_IDLE_DELAY = 80;

export class TracingGameSoundController {
	private drawingIdleTimer?: Phaser.Time.TimerEvent;
	private readonly pencilDrawing: Phaser.Sound.BaseSound;
	private readonly pathFollow: Phaser.Sound.BaseSound;
	private readonly barFill: Phaser.Sound.BaseSound;

	constructor(private readonly scene: Phaser.Scene) {
		this.pencilDrawing = scene.sound.add(TRACING_GAME_SOUND_KEYS.pencilDrawing, {
			loop: true,
			volume: 0,
		});
		this.pathFollow = scene.sound.add(TRACING_GAME_SOUND_KEYS.pathFollow, {
			loop: true,
			volume: TRACING_GAME_SOUND_VOLUMES.pathFollow,
		});
		this.barFill = scene.sound.add(TRACING_GAME_SOUND_KEYS.barFill, {
			loop: true,
			volume: TRACING_GAME_SOUND_VOLUMES.barFill,
		});
	}

	startDrawing() {
		this.setDrawingMoving(false);
		this.playLoop(this.pencilDrawing);
	}

	setDrawingMoving(moving: boolean) {
		this.drawingIdleTimer?.remove();
		this.drawingIdleTimer = undefined;
		if ('setVolume' in this.pencilDrawing && typeof this.pencilDrawing.setVolume === 'function') {
			this.pencilDrawing.setVolume(moving ? TRACING_GAME_SOUND_VOLUMES.pencilDrawing : 0);
		}
		if (moving) {
			this.drawingIdleTimer = this.scene.time.delayedCall(DRAWING_IDLE_DELAY, () => this.setDrawingMoving(false));
		}
	}

	stopDrawing() {
		this.setDrawingMoving(false);
		this.stop(this.pencilDrawing);
	}

	startPathFollow() {
		this.playLoop(this.pathFollow);
	}

	stopPathFollow() {
		this.stop(this.pathFollow);
	}

	playPickup() {
		this.scene.sound.play(TRACING_GAME_SOUND_KEYS.pickup, { volume: TRACING_GAME_SOUND_VOLUMES.pickup });
	}

	playOutOfInk() {
		this.scene.sound.play(TRACING_GAME_SOUND_KEYS.outOfInk, { volume: TRACING_GAME_SOUND_VOLUMES.outOfInk });
	}

	playVictory() {
		this.scene.sound.play(TRACING_GAME_SOUND_KEYS.victory, { volume: TRACING_GAME_SOUND_VOLUMES.victory });
	}

	startBarFill() {
		this.playLoop(this.barFill);
	}

	stopBarFill() {
		this.stop(this.barFill);
	}

	stopAll() {
		this.stopDrawing();
		this.stopPathFollow();
		this.stopBarFill();
	}

	destroy() {
		this.stopAll();
		this.pencilDrawing.destroy();
		this.pathFollow.destroy();
		this.barFill.destroy();
	}

	private playLoop(sound: Phaser.Sound.BaseSound) {
		if (!sound.isPlaying) {
			sound.play();
		}
	}

	private stop(sound: Phaser.Sound.BaseSound) {
		if (sound.isPlaying) {
			sound.stop();
		}
	}
}
